// extracted by mini-css-extract-plugin
export default {"label":"Select_label__r36QN"};